import { Card } from '../ui';

type Props = {
  insights?: string[];
};

export function ProductAdvisorCard({ insights = [] }: Props) {
  return (
    <Card padding="sm" className="border-brand-200 bg-brand-50/20 dark:border-brand-900 dark:bg-brand-950/20">
      <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">AI Product Advisor</p>
      <ul className="mt-3 space-y-2">
        {insights.map((insight) => (
          <li key={insight} className="flex gap-2 text-sm text-slate-600 dark:text-slate-400">
            <span className="text-brand-500">✦</span>
            {insight}
          </li>
        ))}
      </ul>
    </Card>
  );
}
